import React, { useState } from "react";
import "./componentsStyle.css";
import { SendOutlined } from "@ant-design/icons";

import SendButton from '../Images/sendIcon.svg'

export default function Footer(props) {
  const {
    handleKeyPress,
    handleSend,
    handleInput,
    inputValue,
    showMaximumChat,
    checkIntroPage,
    disableInputBox,
    loading,
    isSubscriber,
  } = props;

  return (
    <div
      style={{
        height: showMaximumChat ?  "13vh" : '88%',
        width: "100%",
        borderTop : !checkIntroPage() ? '1px solid #f0ecec' :''
      }}
      className="bot-footer"
    >
      <div className="bot-footer-items" style={{ padding : showMaximumChat &&  '1%'}}>
        <input
          placeholder="Ask a Question"
          onKeyPress={handleKeyPress}
          type="text"
          value={inputValue}
          onChange={(e) => handleInput(e)}
          disabled ={loading  ? true : disableInputBox}
        />
        <img className="send-btn" src={SendButton} alt="sendLogo" onClick={() => handleSend()} ></img>
        {/* <SendOutlined className="send-btn" onClick={() => handleSend()} /> */}
      </div>
    </div>
  );
}
